import { useTheme } from 'styled-components';

type PropsType = {
  overrideStyle?: Record<any, any>;
  eventHandlers?: { onClick?: (...args: any) => any };
};

const CloseIcon = ({ overrideStyle = {}, eventHandlers = {} }: PropsType) => {
  const theme = useTheme();
  return (
    <svg
      style={{ height: 24, width: 24, ...overrideStyle }}
      viewBox="0 0 24 24"
      {...eventHandlers}
    >
      <defs>
        <rect id="close-icon-a" width="16" height="16" x="4" y="4" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="12" cy="12" r="12" fill="transparent" fillRule="nonzero" />
        <mask id="red-close-icon-b" fill={theme.white}>
          <use href="#close-icon-a" />
        </mask>
        <use fill="transparent" fillOpacity="0" href="#close-icon-a" />
        <path
          fill={overrideStyle.color || theme.Grey1}
          d="M13,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L13,13 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L11,11 L11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 L13,11 Z"
          mask="url(#red-close-icon-b)"
          transform="rotate(44 12 12)"
        />
      </g>
    </svg>
  );
};

export default CloseIcon;
